export type SpinnerColor = 'light' | 'dark';
